import './App.css';
import {Grid} from "@mui/system";
import '@fontsource/quicksand/300.css';
import '@fontsource/quicksand/400.css';
import '@fontsource/quicksand/500.css';
import '@fontsource/quicksand/600.css';
import '@fontsource/quicksand/700.css';
import '@fontsource/bebas-neue/400.css';
import {useObtenerDataActualizada} from "./Modulo_Optimizacion_Data/Hooks/useObtenerDataActualizada";
import {createContext, useEffect, useState} from "react";
import {obtenerFechaAct} from "./Servicios/BD/Actualizadores/obtenerFechaAct";
import {collection, query} from "firebase/firestore";
import {fire} from "./fire";
import Pagina from "./Pagina/Pagina";

export const contexApp = createContext()


function App() {
    const [cargando, setCargando] = useState(false)
    const {data: escuelas, actualizarDataLocal: actCEscuelas} = useObtenerDataActualizada({
        clave: 'escuelas',
    })
    const {data: programas, actualizarDataLocal: actProgramas} = useObtenerDataActualizada({
        clave: 'programas',
    })

    const valoresProvider = {
        escuelas,
        programas
    }

    const {Provider} = contexApp;


    const colocarPrioridades = async () => {

        /* setCargando(true)
         let dox = await obtenerCol('productos')
         let productos = dox.data

         for (let producto of productos) {
             let catego = categorias.filter((cat) => cat.nombre === producto.categoria)[0]
             await actualizarDoc('productos', producto.id, {prioridad: catego.prioridad})
         }

         setCargando(false)*/

    }

    if (typeof window !== 'undefined') {
        const windowError = window.onerror;
        window.onerror = function (message, source, lineno, colno, error) {
            if (message.includes('ResizeObserver loop completed with undelivered notifications') ||
                message.includes('ResizeObserver loop limit exceeded')) {
                return true; // Ignora el error y no lo muestra en consola
            }
            return windowError ? windowError(message, source, lineno, colno, error) : false;
        };
    }


    useEffect(() => {

        //se verifica si esta o no actualizado

        obtenerFechaAct('escuelas').then((dox) => {
            let w = []
            let q = query(collection(fire, 'escuelas'))
            actCEscuelas({fecha: dox, wheres: w, query: q}).then()
        })

        obtenerFechaAct('programas').then((dox) => {
            let w = []
            let q = query(collection(fire, 'programas'))
            actProgramas({fecha: dox, wheres: w, query: q}).then()
        })


    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <h1 style={{display: 'none'}}>Formación Técnica Laboral en Ipiales y Nariño | Cessa Universidad</h1>
            <h2 style={{display: 'none'}}>Un modelo innovador basado en Escuelas de Aprendizaje</h2>
            <h2 style={{display: 'none'}}>Técnicos Laborales por Competencias con Alta Empleabilidad</h2>
            <h2 style={{display: 'none'}}>Programas en Salud, Administración, Tecnología y Estética</h2>
            <h2 style={{display: 'none'}}>Inicia tu camino a la Profesionalización y Posgrados</h2>

            <Provider value={valoresProvider}>
                <Pagina/>
            </Provider>

            {/*<Button
                loading={cargando}
                onClick={() => colocarPrioridades()}
            >
                Colocar prioridad
            </Button>*/}

        </Grid>
    );
}

export default App;
